import { GET_CASHFREE_REQUESTED, GET_CASHFREE_VERIFY_REQUESTED } from "resources/actionTypes";

export function postCashfreepayment(getCashfreeDetails) {
  const data = {
    getCashfreeDetail: getCashfreeDetails,
  };
  return {
    type: GET_CASHFREE_REQUESTED,
    payload: data,
  };
}

export function getCashfreeResponse(getCashfreeResponse) {
  const data = {
    getCashfreeResponses: getCashfreeResponse,
  };
  return {
    type: GET_CASHFREE_VERIFY_REQUESTED,
    payload: data,
  };
}
